// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"letters-x"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16 5L16 7.11979C16 7.36471 15.9101 7.60111 15.7474 7.78416L12 12M8 5L8.00001 7.1198C8.00001 7.36472 8.08989 7.60111 8.2526 7.78416L12 12M12 12L8.25259 16.2158C8.08988 16.3989 8.00001 16.6353 8.00001 16.8802L8 19M12 12L15.7474 16.2158C15.9101 16.3989 16 16.6353 16 16.8802L16 19","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-letters-x')
export default class LettersXIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'letters-x',
    }
  }
}
